import type {MouseEvent, ReactElement} from 'react';
import React from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {ContextualMenuInformationBox} from '@Components/contextual-menu/components/contextual-menu-information-box';
import styles from '@Components/poster-editor/components/poster-editing-side-panel/components/item-lock-information-box/item-lock-information-box.module.scss';
import {InformationBoxType} from '@Components/contextual-menu/components/information-box';
import {Text, TextSize} from '@Components/text';
import {isInternalFont} from '@Libraries/font-library';

interface BaseLanguageNotSupportedOptionProps {
  selectedFontFamily: string;
  onClickUseRecommendedFont(): void;
  script: string;
}

export function BaseLanguageNotSupportedOption({...props}: BaseLanguageNotSupportedOptionProps): ReactElement | null {
  const doesScriptMatchSelectedFontFamily = (): boolean => {
    if (!props.script) {
      return false;
    }

    return !isInternalFont(props.selectedFontFamily, props.script);
  };

  const onClickUseRecommendedFont = (e: MouseEvent): void => {
    if ('href' in e.target) {
      props.onClickUseRecommendedFont();
    }
  };

  const getText = (): ReactElement => {
    return (
      <Text
        onClick={onClickUseRecommendedFont}
        size={TextSize.XSMALL}
        val={window.i18next.t('pmwjs_font_incompatible_with_language')}
        dangerouslySetInnerHTML
        className="color-warning-dark"
      />
    );
  };

  return (
    <AnimatePresence>
      {doesScriptMatchSelectedFontFamily() ? (
        <motion.div layout initial={{height: 0}} animate={{height: 'auto'}} transition={{duration: 0.2}} exit={{height: 0}}>
          <ContextualMenuInformationBox containerClassName={styles.infoBox} id="item-lock-movement-info-box" type={InformationBoxType.WARNING}>
            {getText()}
          </ContextualMenuInformationBox>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
